import { render, staticRenderFns } from "./ModalCadastraAvaliado.vue?vue&type=template&id=48af4aaf"
import script from "./ModalCadastraAvaliado.vue?vue&type=script&lang=js"
export * from "./ModalCadastraAvaliado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports